/**
 * What the review queue's URL may carry: which account to open, and which line to put the cursor on.
 *
 * A LINK INTO THE QUEUE, not state the queue keeps. The dashboard's unmatched preview points at one
 * line, and "open the queue" is only half an answer to "this one — whose is it?" when the line is
 * forty rows down. Both are ids, so anything that is not shaped like one is dropped rather than sent
 * on to a query that would refuse it.
 *
 * No zod, for the reason `reports.reconciliation.tsx` gives: `validateSearch` runs on every
 * navigation to the route, and a regex is already enough to say whether a string is a uuid.
 */
export interface QueueSearch {
  account?: string;
  line?: string;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function queueSearch(search: Record<string, unknown>): QueueSearch {
  const result: QueueSearch = {};
  if (typeof search.account === 'string' && UUID.test(search.account)) {
    result.account = search.account;
  }
  if (typeof search.line === 'string' && UUID.test(search.line)) result.line = search.line;
  return result;
}
